<template>
  <div class="editpersonal">
    <div class="personal">
      
      
      <div class="van-cell van-field van-field--error flex" @click="changeAvatar">
        <div class="van-cell__title van-field__label">
          <span>头像</span>
        </div>
        <div class="van-cell__value">
          <div class="van-field__body fr">
            <img class="avatar" :src="tech.thumb?tech.thumb:tech.member_avatar" alt="">
          </div>
        </div>
      </div>

      <div class="van-cell van-field van-field--error">
        <div class="van-cell__title van-field__label">
          <span>姓名</span>
        </div>
        <div class="van-cell__value">
          <div class="van-field__body fr">
            <input type="text" class  v-model="tech.name"/>
          </div>
        </div>
      </div>

      <div class="van-cell van-field van-field--error">
        <div class="van-cell__title van-field__label">
          <span>工作经验(年)</span>
        </div>
        <div class="van-cell__value">
          <div class="van-field__body fr">
            <input type="text" class  v-model="tech.workingtime"/>
          </div>
        </div>
      </div>

      <van-cell-group>
        <van-field
          v-model="tech.desc"
          rows="2"
          autosize
          type="textarea"
          maxlength="150"
          placeholder="请输入个人介绍"
          show-word-limit
        />
      </van-cell-group>
    </div>

    <div class="btn_box">
      <button class="save_btn" @click="save">保存</button>
    </div>


    <van-popup v-model="worktimebox" position="bottom">
      <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            :max-date="maxDate"
            :min-date="minDate"
            :formatter="formatter"
            @confirm="cf_worktime"
            @cancel="_cancel"
          />
    </van-popup>

    

  </div>
</template>

<script>
export default {
  name: "editpersonal",
  components: {},
  data() {
    return {
      currentDate:'',
      worktimebox: false,
      minDate: new Date('1970/01'),
      maxDate: new Date(),
      worktime: '',
      evdaystartime: '',
      evdaystartimebox: false,
      evdayendtime: '',
      evdayendtimebox: false,
      desc:'',
      tech:[]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init(){
      this.get_tech();
    },
    get_tech(){
      this.axios({
        url: this.api.tech.get_tech,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tech = res.tech;
          // that.technician_score = parseFloat(res.tech.score);
        }
      });
    },
    save(){
      this.axios({
        url: this.api.tech.update_tech_info,
        data: {tech_id:this.tech.id,name:this.tech.name,workingtime:this.tech.workingtime,desc:this.tech.desc}
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: res.msg,
            type: "success"
          });
        }
      });
    },
    sel_worktime(){
      this.worktimebox = true;
    },
    _cancel(){
      this.worktimebox = false;
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      }
      return value;
    },
    cf_worktime(value){
      var date = value.getFullYear() + '年' + (value.getMonth() + 1) + '月';
      this.worktime = date;
      this.worktimebox = false;
    },
    sel_evdaystartime(){
      this.evdaystartimebox = true;
    },
    cf_evdaystarttime(value){
      this.evdaystartime = value;
      this.evdaystartimebox = false;
    },
    sel_evdayendtime(){
      this.evdayendtimebox = true;
    },
    cf_evdayendttime(value){
      this.evdayendtime = value;
      this.evdayendtimebox = false;
    },
    changeAvatar(){
      this.$router.push({path:'/techAvatar',query:{tech_id:this.tech.id}});
    }
  }
};
</script>
<style scoped>
.personal {
  background-color: white;
  padding: .75rem .5rem;
  color: #7d7e7e;
}
.btn_box {
  text-align: center;
}
.save_btn {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.4rem 4rem;
  margin-top: 3.5rem;
  font-size: 0.9rem;
}
.van-cell{
  color:#636363;
  font-size:.75rem;
  padding-top:.75rem;
  padding-bottom:.75rem;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: none;
}
.van-field__body input{
  text-align:right;
}
.avatar{
  width:2rem;
  height:2rem;
  border-radius:50%;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/perData/editpersonal.vue